import { Directive } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[decimalValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: DecimalValidatorDirective,
    multi: true
  }]
})
export class DecimalValidatorDirective implements Validator {
  validate(control: AbstractControl): {[key: string]: any} | null {
    const companyDecimalValue = JSON.parse(localStorage.getItem('company_configuration_data'))?.general?.decimal_roundoff || 2;
    const decimalValue = control.value?.toString()?.split('.')[1];
    if (decimalValue && decimalValue?.toString()?.length > companyDecimalValue) {
      return { 'invalidDecimal': true };
    }
    return null;
  }
}
